import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=39a86938"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=39a86938&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports